<template>
  <div class="box">
    <div style="text-align:right;margin-bottom:10px"><Button size="small" @click="$router.go(-1)">返回</Button></div>
    <!-- 大标题 -->
    <h1>{{ name }}</h1>

    <div v-show="info && info.length > 0" v-for="(items, indexs) in info" :key="indexs">
      <!-- part 段落标题-->
      <h2>{{ items.name }}</h2>
      <!-- 段落说明 -->
      <h4 v-if="items.directions">
        <span>Directions:</span>{{ items.directions }}
      </h4>
      <div v-show="items.child && items.child.length > 0" v-for="(item, index) in items.child" :key="index">
        <!-- 类型标题-->
        <h3>{{ item.name }}</h3>
        <!-- 类型说明-->
        <h4 v-if="item.directions">
          <span>Directions:</span>{{ item.directions }}
        </h4>

        <!-- 循环单个考题-->
        <div v-show="item.parts && item.parts.length > 0" v-for="(ite, inde) in item.parts" :key="inde">
          <!-- 考题 -->

          <!-- 全部考题类型 -->
          <!-- 
             1. 四选一的选择题--客观题      type==1
             2. 填空题--客观题             type==2
              基础题--图片--客观题
              填空和翻译---主观题
              听力选择--单个题  type==3 batch==2
              听写选择--多个题   type==3 batch==1
              听力选项带图片--客观题 
              听写--填空        type==4
              阅读理解-- 选择题    type==5
              长篇阅读匹配--填空题  type==6
              n选n--客观题           type==7 
              选词填空（支持词形变化）
              阅读理解选项带图片--客观题
              快速阅读（混杂）
              完形填空                 type==11   
              写作--主观题--支持图片上传  type==11
          -->

          <div class="paper">
            <div class="questions">
              <div class="questions_title">
                {{ ite.name }} (本题{{
                  ite.total_score ? ite.total_score : "未知"
                }}分)
              </div>
              <div class="question_content">
                <!-- ***************题型1 选择题 ******************-->
                <div v-if="is_1(ite)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite)"></div>
                    <div class="text" v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                  </h5>
                  <!-- 选择 -->
                  <div class="select" v-if="ite.question.ques_answers && ite.question.ques_answers.length > 0">
                    <RadioGroup v-model="ite.question.ques_answers[0].answer" vertical>
                      <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">
                        <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                        <Radio disabled :label="it.option_k">
                          <span v-html="it.option"></span>
                        </Radio>
                      </div>
                    </RadioGroup>
                  </div>
                  <div class="analysis">
                    <div class="analysis-row" v-if="
                      ite.question.ques_answers &&
                      ite.question.ques_answers.length > 0
                    ">
                      <span>正确答案：</span>
                      <span v-html="ite.question.formatData.answer.answer"></span>
                    </div>
                    <div class="analysis-row" v-if="
                      ite.question.ques_analysis &&
                      ite.question.ques_analysis.length > 0
                    ">
                      <span>解析：</span>
                      <span>
                        {{ ite.question.ques_analysis[0].analysis }}
                      </span>
                    </div>
                    <div class="analysis-row">
                      <span>考点：</span>
                      <span>
                        {{ ite.question.knowledge || '-' }}
                      </span>
                    </div>

                  </div>
                </div>
                <!-- ***************题型12 多选题 ******************-->
                <div v-if="is_12(ite)">
                  <h5>
                    <span class="index">{{ ite.start }}</span>
                    <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite)"></div>
                    <div class="text" v-else-if="ite.question.ques_stem"
                      v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                  </h5>
                  <!-- 选择 -->
                  <div class="select" v-if="ite.question.ques_answers && ite.question.ques_answers.length > 0">

                    <!-- <RadioGroup v-model="ite.question.ques_answers[0].answer" vertical>
                      <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">
                        <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                        <Radio disabled :label="it.option_k">
                          <span v-html="it.option"></span>
                        </Radio>
                      </div>
                    </RadioGroup> -->

                    <CheckboxGroup class="duoxuan" :value="ite.question.ques_answers[0].answer.split(',')">

                      <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">
                        <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>

                        <Checkbox disabled :label="it.option_k"> <span v-html="it.option"></span></Checkbox>
                      </div>

                    </CheckboxGroup>


                  </div>
                  <div class="analysis">
                    <div class="analysis-row" v-if="
                      ite.question.ques_answers &&
                      ite.question.ques_answers.length > 0
                    ">
                      <span>正确答案：</span>
                      <span v-html="ite.question.formatData.answer.answer"></span>
                    </div>
                    <div class="analysis-row" v-if="
                      ite.question.ques_analysis &&
                      ite.question.ques_analysis.length > 0
                    ">
                      <span>解析：</span>
                      <span>
                        {{ ite.question.ques_analysis[0].analysis }}
                      </span>
                    </div>
                    <div class="analysis-row">
                      <span>考点：</span>
                      <span>
                        {{ ite.question.knowledge || '-' }}
                      </span>
                    </div>

                  </div>
                </div>
                <!-- ***************题型2 填空题 ******************-->
                <Col v-if="is_2(ite)">
                <h5>
                  <span class="index">{{ ite.start }}</span>
                  <!-- <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div> -->
                  <div class="text" v-if="ite.question.formatData" v-html="set_input_2(ite)"></div>
                </h5>
                <div style="display:flex;width:100%;margin:0 0 1vh 1vw" v-if="ite.question.ques_answers">
                  <p>答案：</p>
                  <Input style="width:90%" readonly type="textarea" :value="ite.question.ques_answers[0].answer.replace(
                    /<[^<>]+>/g,
                    ''
                  )
                    ">
                  </Input>
                </div>
                </Col>
                <!-- ***************题型3 听力选择题----单个问题 ******************-->

                <Col v-if="is_3(ite, 2)">
                <!-- //大标题 -->
                <h5>
                  <span class="index">{{ ite.start }}</span>
                  <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite)"></div>
                  <div class="text" v-else-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                  </div>
                </h5>
                <!-- //大音频 -->
                <div class="audio">
                  <audio controlsList="nodownload" style="width: 180px; height: 30px"
                    v-if="ite.question.formatData.stem_src_audio" :ref="'audio' + index" controls
                    :src="ite.question.formatData.stem_src_audio"></audio>
                </div>

                <!-- 选择 -->
                <div class="select" v-if="ite.question.ques_answers">
                  <!-- ite.question.ques_answers[0].answer -->
                  <RadioGroup v-model="ite.question.ques_answers[0].answer" vertical disabled>
                    <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">
                      <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                      <Radio disabled :label="it.option_k">
                        <span v-html="it.option"></span>
                      </Radio>
                    </div>
                  </RadioGroup>
                </div>

                <div class="analysis">
                  <div class="analysis-row" v-if="
                    ite.question.ques_answers &&
                    ite.question.ques_answers.length > 0
                  ">
                    <span>正确答案：</span>
                    <span v-html="String.fromCharCode(65 + parseInt(ite.question.ques_answers[0].answer))"></span>
                  </div>
                  <div class="analysis-row" v-if="
                    ite.question.ques_analysis &&
                    ite.question.ques_analysis.length > 0
                  ">
                    <span>解析：</span>
                    <span>
                      {{ ite.question.ques_analysis[0].analysis }}
                    </span>
                  </div>
                  <div class="analysis-row">
                    <span>考点：</span>
                    <span>
                      {{ ite.question.knowledge || '-' }}
                    </span>
                  </div>

                </div>
                </Col>

                <!-- ***************题型3 听力----多个问题 ******************-->
                <Col v-if="is_3(ite, 1)">
                <!-- //大音频 -->
                <div class="audio">
                  <audio controlsList="nodownload" style="width: 180px; height: 30px"
                    v-if="ite.question.formatData.stem_src_audio" :ref="'audio' + index" controls
                    :src="ite.question.formatData.stem_src_audio"></audio>
                </div>
                <!-- //大标题 -->
                <h5>
                  <span class="index" style="background: #fff"></span>
                  <!-- <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div> -->
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>
                <!-- 单个问题 -->
                <div v-if="ite.question.formatData">
                  <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                    <h5>
                      <span class="index">{{ ite.start + i }}</span>
                      <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                      <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                    </h5>
                    <div class="audio">
                      <audio controlsList="nodownload" style="width: 180px; height: 30px" v-if="li.sub_src_audio"
                        :ref="'audio' + index" controls :src="li.sub_src_audio"></audio>
                    </div>
                    <div class="select">
                      <RadioGroup vertical disabled v-model="li.answer.answer">
                        <div v-for="(it, ind) in li.options" :key="ind" class="radio-wrapper">
                          <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                          <Radio disabled :label="String(ind)">
                            <span v-html="it.option"></span>
                          </Radio>
                        </div>
                      </RadioGroup>
                    </div>

                    <!-- 答案 -->
                    <div class="analysis">
                      <div class="analysis-row" v-if="li.answer">
                        <span>正确答案：</span>
                        <span v-html="String.fromCharCode(65 + li.answer.answer * 1)
                          "></span>
                      </div>
                      <div class="analysis-row" v-if="li.analysis">
                        <span>解析：</span>
                        <span>
                          {{ li.analysis.analysis }}
                        </span>
                      </div>
                      <div class="analysis-row">
                        <span>考点：</span>
                        <span>
                          {{ ite.question.knowledge || '-' }}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                </Col>

                <!-- ***************题型4 听力填空题 ******************-->
                <Col v-if="is_4(ite)">
                <!-- //大音频 -->
                <div class="audio">
                  <audio controlsList="nodownload" style="width: 180px; height: 30px"
                    v-if="ite.question.formatData.stem_src_audio" :ref="'audio' + index" controls
                    :src="ite.question.formatData.stem_src_audio"></audio>
                </div>
                <!-- //大标题 -->
                <h5>
                  <!-- <span class="index">{{ ite.start }}</span> -->
                  <!-- <div
                      class="text"
                      v-if="have_sub_heading(ite)"
                      v-html="set_sub_heading(ite)"
                    ></div> -->

                  <div class="text" v-if="ite.question.formatData" v-html="set_input_4(ite)"></div>
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>
                </Col>

                <!-- ***************题型5 阅读理解单个题 ******************-->
                <Col v-if="is_5(ite, 2)">
                <h5>
                  <span class="index">{{ ite.start }}</span>
                  <div class="text" v-if="have_sub_heading(ite)" v-html="set_sub_heading(ite)"></div>
                  <div class="text" v-else-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                  </div>
                </h5>
                <!-- 选择 -->
                <div class="select" v-if="ite.question.ques_answers">
                  <!-- ite.question.ques_answers[0].answer -->
                  <RadioGroup v-model="ite.question.ques_answers[0].answer" vertical disabled>
                    <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">
                      <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                      <Radio disabled :label="it.option_k">
                        {{ it.option_k }}.
                        <span v-html="it.option"></span>
                      </Radio>
                    </div>
                  </RadioGroup>
                </div>
                </Col>

                <!-- ***************题型5 阅读理解多个题  ******************-->
                <Col v-if="is_5(ite, 1)">
                <!-- //大标题 -->
                <h5>
                  <span class="index" style="background: #fff"></span>
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>

                <!-- 单个问题 -->
                <div v-if="ite.question.formatData">
                  <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                    <h5>
                      <span class="index">{{ ite.start + i }}</span>
                      <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                      <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                    </h5>

                    <div class="select">
                      <RadioGroup vertical disabled v-model="li.answer.answer">
                        <div v-for="(it, ind) in li.options" :key="ind" class="radio-wrapper">
                          <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                          <Radio disabled :label="String(ind)">
                            <span v-html="it.option"></span>
                          </Radio>
                        </div>
                      </RadioGroup>
                    </div>
                    <!-- 答案 -->
                    <div class="analysis">
                      <div class="analysis-row" v-if="li.answer">
                        <span>正确答案：</span>
                        <span v-html="String.fromCharCode(65 + li.answer.answer * 1)
                          "></span>
                      </div>
                      <div class="analysis-row" v-if="li.analysis">
                        <span>解析：</span>
                        <span>
                          {{ li.analysis.analysis }}
                        </span>
                      </div>
                      <div class="analysis-row">
                        <span>考点：</span>
                        <span>
                          {{ ite.question.knowledge || '-' }}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                </Col>

                <!-- ***************题型6 长篇阅读_填空题  ******************-->
                <Col v-if="is_6(ite)">
                <!-- //大标题 -->
                <h5>
                  <span class="index" style="background: #fff"></span>
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>
                <!-- 单个问题 -->
                <div v-if="ite.question.formatData">
                  <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                    <h5>
                      <span class="index">{{ ite.start + i }}</span>
                      <div class="text" v-if="li.sub_heading" v-html="set_input_9(li.sub_heading, li.answer)"></div>

                      <!-- <div
                          class="text"
                          v-if="li.sub_src_txt"
                          v-html="li.sub_src_txt"
                        ></div> -->
                    </h5>
                    <!-- 答案 -->
                    <div class="analysis">
                      <!-- <div class="analysis-row" v-if="li.answer">
                            <span>正确答案：</span>
                            <span v-html="li.answer[0].answer"></span>
                          </div> -->
                      <div class="analysis-row" v-if="li.analysis">
                        <span>解析：</span>
                        <span>
                          {{ li.analysis.analysis }}
                        </span>
                      </div>
                      <div class="analysis-row">
                        <span>考点：</span>
                        <span>
                          {{ ite.question.knowledge || '-' }}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                </Col>

                <!-- ***************题型7 n选n选择题  ******************-->
                <Col v-if="is_7(ite)">
                <h5>
                  <!-- <span class="index">{{ ite.start }}</span> -->
                  <!-- //大问题文章带input -->
                  <div class="text" v-if="ite.question && ite.question.formatData.stem != ''"
                    v-html="set_input(ite.start, ite.question.formatData)">
                    <!-- set_input 往input 中设置 文字 -->
                  </div>
                  <div class="text" v-else-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt">
                  </div>
                </h5>
                <!-- 选择 -->
                <div class="select_no" v-if="ite.question.ques_answers">
                  <RadioGroup v-model="ite.question.ques_answers[0].answer" vertical>
                    <div v-for="(it, ind) in ite.question.ques_options" :key="ind" class="radio-wrapper">

                      <Radio disabled :label="it.option_k">
                        {{ it.option_k }}.
                        <span v-html="it.option"></span>
                      </Radio>
                    </div>
                  </RadioGroup>
                </div>

                </Col>

                <!-- ***************题型8 选择题文本资源 题型9 填空题带文本资源 ******************-->
                <Col v-if="is_8_9(ite)">
                <!-- //大标题 -->
                <h5>
                  <span class="index" style="background: #fff"></span>
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>

                <!-- 单个问题      -->
                <div v-if="ite.question.formatData">
                  <div v-for="(li, w) in ite.question.formatData.sub_headings" :key="w">
                    <!--  这里 是  88888888888888 类型   -->
                    <div v-if="li.options && li.options.length > 0">
                      <h5>
                        <span class="index">{{ ite.start + w }}</span>
                        <div class="text" v-if="li.sub_heading" v-html="li.sub_heading"></div>
                        <div class="text" v-if="li.sub_src_txt" v-html="li.sub_src_txt"></div>
                      </h5>

                      <div class="select" v-if="li.answer[0]">
                        <RadioGroup vertical disabled v-model="li.answer[0].answer">
                          <div v-for="(it, ind) in li.options" :key="ind" class="radio-wrapper">
                            <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                            <Radio disabled :label="String(ind)">
                              <span v-html="it.option"></span>
                            </Radio>
                          </div>
                        </RadioGroup>
                      </div>

                      <!-- 答案 -->
                      <div class="analysis" v-if="li.answer && li.answer[0]">
                        <div class="analysis-row" v-if="li.answer">
                          <span>正确答案：</span>
                          <span v-html="String.fromCharCode(
                            65 + li.answer[0].answer * 1
                          )
                            "></span>
                        </div>
                        <div class="analysis-row" v-if="li.analysis">
                          <span>解析：</span>
                          <span>
                            {{ li.analysis.analysis }}
                          </span>
                        </div>
                        <div class="analysis-row">
                          <span>考点：</span>
                          <span>
                            {{ ite.question.knowledge || '-' }}
                          </span>
                        </div>

                      </div>
                    </div>

                    <!-- 填空题  这里是 99999999999999999999 类型 -->

                    <div v-else>
                      <h5>
                        <span class="index">{{ ite.start + w }}</span>

                        <div class="text" v-if="li.sub_heading" v-html="set_input_9(li.sub_heading, li.answer)"></div>
                      </h5>
                      <!-- 答案 -->
                      <div class="analysis">
                        <!-- <div class="analysis-row" v-if="li.answer">
                            <span>正确答案：</span>
                            <span v-html="li.answer[0].answer"></span>
                          </div> -->
                        <div class="analysis-row" v-if="li.analysis">
                          <span>解析：</span>
                          <span>
                            {{ li.analysis.analysis }}
                          </span>
                        </div>
                        <div class="analysis-row">
                          <span>考点：</span>
                          <span>
                            {{ ite.question.knowledge || '-' }}
                          </span>
                        </div>

                      </div>
                    </div>

                    <!-- 结束 -->
                  </div>
                </div>
                </Col>

                <!-- ***************题型10 完形填空_填空题  ******************-->
                <Col v-if="is_10(ite)">
                <!-- //大标题 -->
                <h5>
                  <span class="index" style="background: #fff"></span>
                  <div class="text" v-if="ite.question.ques_stem" v-html="ite.question.ques_stem[0].stem_src_txt"></div>
                </h5>

                <!-- 单个问题 -->
                <div v-if="ite.question.formatData">
                  <div v-for="(li, i) in ite.question.formatData.sub_headings" :key="i">
                    <h5>
                      <span class="index" v-if="ite.start">{{
                        ite.start + i
                      }}</span>
                      <!-- <div
                          class="text"
                          v-if="li.sub_heading"
                          v-html="li.sub_heading"
                        ></div>
                        <div
                          class="text"
                          v-if="li.sub_src_txt"
                          v-html="li.sub_src_txt"
                        ></div> -->
                    </h5>

                    <div class="select">
                      <RadioGroup vertical disabled v-model="li.answer.answer">
                        <div v-for="(it, ind) in li.options" :key="ind" class="radio-wrapper">
                          <span class="radio-text">{{ String.fromCharCode(65 + ind) }}.</span>
                          <Radio disabled :label="String(ind)">
                            <span v-html="it.option"></span>
                          </Radio>
                        </div>
                      </RadioGroup>
                    </div>

                    <!-- 答案 -->
                    <div class="analysis">
                      <div class="analysis-row" v-if="li.answer">
                        <span>正确答案：</span>
                        <span v-html="String.fromCharCode(65 + li.answer.answer * 1)
                          "></span>
                      </div>
                      <div class="analysis-row" v-if="li.analysis">
                        <span>解析：</span>
                        <span>
                          {{ li.analysis.analysis }}
                        </span>
                      </div>
                      <div class="analysis-row">
                        <span>考点：</span>
                        <span>
                          {{ ite.question.knowledge || '-' }}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                </Col>

                <!-- 写作题 -->
                <Col v-if="is_11(ite)">
                <!-- <p class="e-list-c-b">作文关键词：<span v-html="item.detailData.formatData.stem"></span></p> -->
                <div style="height: 12px"></div>

                <div>
                  <p v-html="ite.question.ques_stem[0].stem"></p>
                </div>
                <div style="height: 12px"></div>
                <p>
                  字数建议：下限：
                  <span v-html="ite.question.ques_stem[0].limit_l"></span>上限：<span
                    v-html="ite.question.ques_stem[0].limit_r"></span>
                </p>

                <div style="height: 12px"></div>
                <Input readonly type="textarea" :value="ite.question.ques_answers[0].answer.replace(
                  /<[^<>]+>/g,
                  ''
                )
                  "></Input>
                <div style="height: 12px"></div>
                </Col>
              </div>

              <!-- 答案 -->
              <div class="analysis" v-if="
                !is_1(ite) &&
                !is_12(ite) &&
                !is_3(ite, 1) &&
                !is_3(ite, 2) &&
                !is_5(ite, 1) &&
                !is_6(ite) &&
                !is_7(ite) &&
                !is_10(ite) &&
                !is_8_9(ite)
              ">
                <div class="analysis-row" v-if="
                  ite.question.ques_answers &&
                  ite.question.ques_answers.length > 0
                ">
                  <!-- <span>正确答案：</span>
                  <span v-html="ite.question.ques_answers[0].answer"></span> -->
                </div>
                <div class="analysis-row" v-if="
                  ite.question.ques_analysis &&
                  ite.question.ques_analysis.length > 0
                ">
                  <span>解析：</span>
                  <span>
                    {{ ite.question.ques_analysis[0].analysis }}
                  </span>
                </div>
                <div class="analysis-row">
                  <span>考点：</span>
                  <span>
                    {{ ite.question.knowledge || '-' }}
                  </span>
                </div>

              </div>
              <div class="analysis" v-if="is_7(ite)">
                <div class="analysis-row" v-if="
                  ite.question.ques_analysis &&
                  ite.question.ques_analysis.length > 0
                ">
                  <span>解析：</span>
                  <span>
                    {{ ite.question.ques_analysis[0].analysis }}
                  </span>
                </div>
                <div class="analysis-row">
                  <span>考点：</span>
                  <span>
                    {{ ite.question.knowledge || '-' }}
                  </span>
                </div>

              </div>
            </div>

            <!-- 结束 -->
          </div>
        </div>
      </div>
      <!-- 结束 -->
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      a: "",
      name: "",
      info: [],
      id: "",
      template_id: "",
    };
  },
  activated() {
    var that = this;

    that.id = that.$route.query.id;

    that.template_id = that.$route.query.template_id;

    this.get_info(that.template_id);
  },
  methods: {
    get_info(id) {
      this.$axios
        .get("/app/source_exam_paper/getInfo?id=" + this.id)
        .then((res) => {
          this.name = res.data ? res.data.name : null;
          this.info = res.data.template ? res.data.template.catalog : [];
        });
    },
    have_sub_heading(ite) {
      return (
        ite.question.ques_sub_headings &&
        ite.question.ques_sub_headings.length > 0 &&
        ite.question.ques_sub_headings[0].sub_heading != ""
      );
    },
    set_sub_heading(ite) {
      return ite.question.ques_sub_headings[0].sub_heading;
    },

    // 完型填空类往inpu 中添加文字
    set_input(start, ites) {
      let stem = ites.stem;
      let answer = ites.answer;
      // let options = item.options;

      let arr = stem.split("<Input/>");
      let newArr = "";

      // 2.筛选出两个数组相同的元素

      // let list = [];
      // list = this.options.filter((item) => {
      //   return array2.indexOf(item) !== -1;
      // });

      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          // newArr +=
          //   item +
          //   "<Input readonly='readonly' value= '" +
          //   answer[index].answer +
          //   "'/>";
          newArr += item + "<h5><span class='index'>" + (start + index) + "</span></h5>" + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },

    //题型2的 填空题往inpu 中添加文字
    set_input_2(ite) {
      let stem = ite.question.formatData.stem;
      // let answer = ite.question.formatData.answer;

      // let arr = stem.split("<Input/>");
      // let newArr = "";
      // arr.map(function (item, index) {
      //   if (index < arr.length - 1) {
      //     // newArr +=
      //     //   item +
      //     //   "<Input readonly='readonly' value= '" +
      //     //   answer[index].answer +
      //     //   "'/>";
      //     newArr += item +"<p style='width:63vw'>"+ `<textarea disabled rows="3">${answer[index].answer}</textarea>`+ "</p>";
      //   } else {
      //     newArr += item;
      //   }
      // });
      return stem;
    },
    //题型4的 填空题往inpu 中添加文字
    set_input_4(ite) {
      var reg = /<answer(.*?)>(.*?)<\/answer>/g;
      let stem = ite.question.ques_sub_headings[0].sub_heading;
      let newArr = "";
      let stem2 = ite.question.ques_sub_headings[0].sub_heading.split(reg);
      if (stem2.length > 1) {
        newArr = stem.replace("<answer", "<pre");
        newArr = newArr.replace("</answer", "</pre");
        return newArr;
      }
      let answer = ite.question.ques_answers;
      console.log(answer);
      let arr = stem.split("<Input/>");
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          // newArr +=
          //   item +
          //   "<Input readonly='readonly' value= '" +
          //   answer[index].answer +
          //   "'/>";
          newArr += item + "<h5><span class='index'>" + (ite.start + index) + "</span></h5>" + "<pre>" + answer[index].answer + "</pre>";
        } else {
          newArr += item;
        }
      });
      return newArr;
    },
    // 9类型填空类往inpu 中添加文字
    set_input_9(item, answer_arr) {
      let stem = item;
      let answer = answer_arr;

      let arr = stem.split("<Input/>");
      let newArr = "";
      arr.map(function (item, index) {
        if (index < arr.length - 1) {
          // newArr +=
          //   item +
          //   "<Input readonly='readonly' value= '" +
          //   answer[index].answer +
          //   "'/>";
          newArr += item + "<pre>" + answer[index].answer + "</pre>";
        }
      });
      return newArr;
    },

    //判断类型
    //基础选择题
    is_1(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 1;
      }
    },
    //多选题
    is_12(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 12;
      }
    },
    //基础填空题
    is_2(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == "2";
      }
    },
    //听力选择题
    is_3(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 3 &&
          item.question.question_type.batch == num
        );
      }
    },
    //听力填空题
    is_4(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 4;
      }
    },

    //阅读理解选择题 单个
    is_5(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 5 &&
          item.question.question_type.batch == num
        );
      }
    },
    //阅读理解填空题 多个
    is_5(item, num) {
      if (item.question && item.question.formatData) {
        return (
          item.question.question_type.basic_ques_types == 5 &&
          item.question.question_type.batch == num
        );
      }
    },
    //长篇阅读
    is_6(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 6;
      }
    },
    //  <!-- n选n选择题 -->
    is_7(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 7;
      }
    },

    is_8_9(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == "8,9";
      }
    },
    // <!-- 完形填空 -->
    is_10(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 10;
      }
    },

    //是否是写作题
    is_11(item) {
      if (item.question && item.question.formatData) {
        return item.question.question_type.basic_ques_types == 11;
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/.text>* {
  display: inline-block;
}

/deep/pre {
  border-bottom: 1px solid #333;
  display: inline-block;
  padding: 0 30px;
  min-width: 100px;
  color: #19be6b;
}

//选项颜色
/deep/.ivu-radio-disabled .ivu-radio-inner:after {
  background: #19be6b;
}

/deep/.ivu-radio-checked .ivu-radio-inner {
  border-color: #19be6b;
}

/deep/img {
  max-width: 320px !important;
}

/deep/textarea {
  display: inline-block;
  width: 100% !important;
}

/deep/input {
  border: none;
  border-bottom: 1px solid #999 !important;
  outline: none;
  text-align: center;
  font-weight: bold;
  color: #19be6b;
}

.radio-wrapper {
  position: relative;

  .radio-text {
    display: inline-block;
    position: absolute;
    top: 9px;
    left: 20px;
  }
}

//音频播放器样式修改
.audio {
  // border-radius: 100px;
  padding: 10px 30px 5px 0;
  margin-bottom: 10px;
  // background: #34495d;
  // width: 380px !important;
  // height: 80px !important;
  // box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
}

audio::-webkit-media-controls {
  border: 0;
  // border-radius: 100px;
  // background: #34495d;
  // box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
  width: 380px !important;
  height: 80px !important;
  display: flex;
  align-items: center;
}

/* 音频面板 */
audio::-webkit-media-controls-panel {
  // padding: 20px;
  // width: 380px !important;

  // height: 80px !important;
  background: #fff;
}

/* 音量按钮 */
audio::-webkit-media-controls-mute-button {
  background: #fff;
}

/* 播放按钮 */
audio::-webkit-media-controls-play-button {
  // width: 50px;
  // height: 50px;
}

audio::-webkit-media-controls-play-button-icon {
  background: #fff;
  width: 50px;
  height: 50px;
}

audio::-webkit-media-controls-timeline-container {
  background: rgb(129, 128, 128);
}

/* 当前播放时长 */
audio::-webkit-media-controls-current-time-display {}

/* 总时长 */
audio::-webkit-media-controls-time-remaining-display {}

/* 播放进度条 */
audio::-webkit-media-controls-timeline {
  // display: none;
  width: 100px;
  //进度
}

/* 音量滑条面板 */
audio::-webkit-media-controls-volume-slider-container {}

audio::-webkit-media-controls-volume {
  background: rgb(6, 173, 145);
}

/* 音量滑条 */
audio::-webkit-media-controls-volume-slider {
  // background: rgb(6, 173, 145);
  display: none;
  // 音量进度
}

/* 后退按钮 */
audio::-webkit-media-controls-seek-back-button {}

/* 快进按钮 */
audio::-webkit-media-controls-seek-forward-button {}

/* 全屏按钮 */
audio::-webkit-media-controls-fullscreen-button {}

audio::-webkit-media-controls-rewind-button {}

audio::-webkit-media-controls-return-to-realtime-button {}

audio::-webkit-media-controls-toggle-closed-captions-button {}

//大盒子
.box {
  padding: 0 30px 30px;
  background: #fff;
}

h1 {
  font-size: 28px;
  line-height: 64px;
  color: #333;
  font-weight: bold;
  text-align: center;
}

h2 {
  //大标题
  font-size: 28px;
  line-height: 56px;
  color: #333;
  font-weight: bold;
  text-align: left;
}

h3 {
  //大标题
  font-size: 18px;
  line-height: 48px;
  color: #333;
  font-weight: bold;
  text-align: left;
}

h4 {
  margin-bottom: 12px;
  //大标题
  font-size: 14px;
  font-weight: normal;
  color: #999;
  text-align: left;

  span {
    font-size: 16px;
    color: #666;
    font-weight: bold;
  }
}

//h5 是问题字段
/deep/ h5 {
  display: flex;
  // align-items: center;
  padding-left: 10px;
  padding-top: 10px;
  margin-bottom: 10px;

  //小标题下标
  .index {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    display: inline-block;
    background: #19be6b;
    border-radius: 50%;
    margin-right: 16px;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }

  //小标题
  .text {
    // line-height: 30px;
  }
}

//考题大盒子

.paper {
  color: #27274a;
  width: 100%;
  background: #ffffff;
  border-radius: 4px;

  .questions {
    border: 1px solid #dedede;
    margin-bottom: 30px;

    .questions_title {
      margin-bottom: 20px;
      font-size: 18px;
      line-height: 25px;
      padding: 18px 20px;
      background: #fafafa;
      border-bottom: 1px solid #dedede;
      position: relative;
    }

    .question_content {
      // display: flex;
      align-items: center;
      font-size: 16px;
      line-height: 22px;
      // margin-bottom: 10px;
      // padding-left: 20px;
      // padding-right: 20px;
    }

    .analysis {
      padding: 20px;

      font-size: 14px;
      border-top: 1px solid #dedede;
      position: relative;
      background: #fafafa;
      position: relative;
    }
  }
}

.select label {
  width: 100%;
  padding: 10px 10px 10px 45px;
  line-height: 20px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: relative;
  min-height: 40px;
  height: auto;
  display: flex;
}

.select_no label {
  width: 100%;
  padding: 10px 10px 10px 45px;
  line-height: 20px;
  border-radius: 4px;
  cursor: pointer;
  margin: 0;
  position: relative;
  min-height: 40px;
  height: auto;
  display: flex;

  /deep/.ivu-radio-disabled {
    display: none;
  }
}

/deep/span img {
  vertical-align: top;
}


/deep/.duoxuan {
  .ivu-checkbox {
    margin-right: 10px;
  }

  .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #19be6b;
    background-color: #19be6b;


  }

  .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #19be6b;
    background-color: #19be6b;
    border: 1px solid #19be6b;
  }

  .ivu-checkbox-disabled.ivu-checkbox-checked+span {
    color: #19be6b;
    cursor: not-allowed;
  }

  .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
    animation-name: none;
    border-color: #fff;
  }
}
</style>
